export default __webpack_public_path__ + "static/media/bigstock-Hands-Raised-In-The-Crowd.b1cc9ef3.jpg";